import { render, staticRenderFns } from "./CompanyLayout.vue?vue&type=template&id=d84ca754&scoped=true"
import script from "./CompanyLayout.vue?vue&type=script&lang=js"
export * from "./CompanyLayout.vue?vue&type=script&lang=js"
import style0 from "./CompanyLayout.vue?vue&type=style&index=0&id=d84ca754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84ca754",
  null
  
)

export default component.exports